export default __webpack_public_path__ + "static/media/ltr.26d58395.svg";